export default __webpack_public_path__ + "static/media/BADGES_FINAL_PSM-I_600.a20938e1.png";